/**
 * Centralized feature color mapping (industry-standard)
 * Drives glow cards, accents, badges, focus states across features.
 * Keep this file as the single source of truth.
 */

export const FEATURE_COLORS = {
    sales: {
        key: 'sales',
        label: 'Sales',
        glowClass: 'glow-sales',
        gradient: 'linear-gradient(137deg, #16A34A 0%, #4ADE80 45%, #86EFAC 100%)',
        hex: '#22C55E',
        tint: 'rgba(34,197,94,0.10)',
        text: '#4ADE80',
        border: 'rgba(34,197,94,0.30)',
    },
    stock: {
        key: 'stock',
        label: 'Stock',
        glowClass: 'glow-stock',
        gradient: 'linear-gradient(137deg, #F59E0B 0%, #FBBF24 45%, #FCD34D 100%)',
        hex: '#F59E0B',
        tint: 'rgba(245,158,11,0.10)',
        text: '#FBBF24',
        border: 'rgba(245,158,11,0.30)',
    },
    invoice: {
        key: 'invoice',
        label: 'Invoices',
        glowClass: 'glow-invoice',
        gradient: 'linear-gradient(137deg, #7C3AED 0%, #A78BFA 45%, #C4B5FD 100%)',
        hex: '#8B5CF6',
        tint: 'rgba(139,92,246,0.10)',
        text: '#A78BFA',
        border: 'rgba(139,92,246,0.30)',
    },
    credit: {
        key: 'credit',
        label: 'Credit',
        glowClass: 'glow-credit',
        gradient: 'linear-gradient(137deg, #DC2626 0%, #F87171 45%, #FCA5A5 100%)',
        hex: '#EF4444',
        tint: 'rgba(239,68,68,0.10)',
        text: '#F87171',
        border: 'rgba(239,68,68,0.30)',
    },
    customer: {
        key: 'customer',
        label: 'Customers',
        glowClass: 'glow-customer',
        gradient: 'linear-gradient(137deg, #0891B2 0%, #22D3EE 45%, #67E8F9 100%)',
        hex: '#06B6D4',
        tint: 'rgba(6,182,212,0.10)',
        text: '#22D3EE',
        border: 'rgba(6,182,212,0.30)',
    },
    supplier: {
        key: 'supplier',
        label: 'Suppliers',
        glowClass: 'glow-supplier',
        gradient: 'linear-gradient(137deg, #0D9488 0%, #2DD4BF 45%, #5EEAD4 100%)',
        hex: '#14B8A6',
        tint: 'rgba(20,184,166,0.10)',
        text: '#2DD4BF',
        border: 'rgba(20,184,166,0.30)',
    },
    payment: {
        key: 'payment',
        label: 'Payments',
        glowClass: 'glow-payment',
        gradient: 'linear-gradient(137deg, #059669 0%, #34D399 45%, #6EE7B7 100%)',
        hex: '#10B981',
        tint: 'rgba(16,185,129,0.10)',
        text: '#34D399',
        border: 'rgba(16,185,129,0.30)',
    },
    ai: {
        key: 'ai',
        label: 'AI Insights',
        glowClass: 'glow-ai',
        gradient: 'linear-gradient(137deg, #4361EE 0%, #E0AEFF 45%, #F72585 100%)',
        hex: '#A855F7',
        tint: 'rgba(168,85,247,0.10)',
        text: '#E879F9',
        border: 'rgba(168,85,247,0.30)',
    },
    analytics: {
        key: 'analytics',
        label: 'Analytics',
        glowClass: 'glow-analytics',
        gradient: 'linear-gradient(137deg, #1D4ED8 0%, #60A5FA 45%, #93C5FD 100%)',
        hex: '#3B82F6',
        tint: 'rgba(59,130,246,0.10)',
        text: '#60A5FA',
        border: 'rgba(59,130,246,0.30)',
    },
    neutral: {
        key: 'neutral',
        label: 'Neutral',
        glowClass: 'glow-neutral',
        gradient: 'linear-gradient(137deg, #3F3F46 0%, #71717A 45%, #A1A1AA 100%)',
        hex: '#71717A',
        tint: 'rgba(113,113,122,0.10)',
        text: '#A1A1AA',
        border: 'rgba(113,113,122,0.30)',
    },
};

export const getFeatureColor = (key) => FEATURE_COLORS[key] || FEATURE_COLORS.neutral;
